import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UnlockedCandidateList } from "./UnlockedCandidateListAPI";

const initialState = {
    data: null,
    loading: false,
    error: null,
    successMessage: null,
};

export const UnlockedCandidateListAsync = createAsyncThunk(
    "UnlockedCandidateList/get",
    async ({ page = 1, per_page = 15 }, { rejectWithValue }) => {
        try {
            const data = await UnlockedCandidateList(page, per_page);
            // console.log("Unlock API response data:", data);
            return data?.response;
        } catch (error) {
            console.error("Error in UnlockCandidateAsync:", error);
            return rejectWithValue(error.message || "Failed to unlock candidate");
        }
    }
);

const UnlockedCandidateListSlice = createSlice({
    name: "UnlockedCandidateList",
    initialState,
    reducers: {
        resetUnlockState: (state) => {
            state.data = null;
            state.error = null;
            state.successMessage = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(UnlockedCandidateListAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.successMessage = null;
            })
            .addCase(UnlockedCandidateListAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.successMessage = "Candidate unlocked successfully";
                state.error = null;
            })
            .addCase(UnlockedCandidateListAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to unlock candidate";
                state.successMessage = null;
            });
    },
});

export const { resetUnlockState } = UnlockedCandidateListSlice.actions;
export const selectUnlockedCandidateList = (state) => state.UnlockedCandidateList;
export default UnlockedCandidateListSlice.reducer;